import { observer } from 'mobx-react-lite';
import { ElementConfigType } from '../store/type';
import { PageEditorStoreContext } from '../store/PageEditorStore';
import ComponentFactory from '../component-factory/ComponentFactory';
import React, { useContext, useEffect, useMemo } from 'react';
import { ComponentBasicRender } from '@/pages2/DetailedDescription/editor/ComponentBasicRender';
import { StylingHOC, WrapperHOC } from '../HOC';
import { lazy } from 'ice';
import { transformReactCSS } from '../utils';

/**
 * 数组元素交换位置
 * @param {array} arr 数组
 * @param {number} index1 添加项目的位置
 * @param {number} index2 删除项目的位置
 * index1和index2分别是两个数组的索引值，即是两个要交换元素位置的索引值，如1，5就是数组中下标为1和5的两个元素交换位置
 */

const DevelopmentWrapper = WrapperHOC(lazy(() => import('./DevelopmentWrapper')));

const ComponentItemRender = observer((props: ElementConfigType) => {
  const { componentId } = props;

  const currentComponent = ComponentFactory.getComponentById(componentId);
  const Component = useMemo(() => StylingHOC(currentComponent), [currentComponent]);
  const pageEditorStore = useContext(PageEditorStoreContext);

  const initStyleToRule = (componentConfig: ElementConfigType) => {
    const initStyle = currentComponent?.definition.computeStyle
      ? currentComponent?.definition.computeStyle(componentConfig)
      : componentConfig.styles;

    pageEditorStore.updateDefaultRule(componentConfig.nodeId, transformReactCSS(initStyle));
  };

  useEffect(() => {
    pageEditorStore.isDevelopment && initStyleToRule(props);
  }, []);

  return pageEditorStore.isDevelopment ? (
    <DevelopmentWrapper {...props}>
      <Component {...props} ComponentBasicRender={ComponentBasicRender} ComponentItemRender={ComponentItemRender} />
    </DevelopmentWrapper>
  ) : (
    <Component {...props} ComponentBasicRender={ComponentBasicRender} ComponentItemRender={ComponentItemRender} />
  );
});

export default ComponentItemRender;
